import axios from 'axios'
import SecureLS from 'secure-ls'
import { createAuthInterceptor } from './interceptors'

const secureLs = new SecureLS()

const api = axios.create({
  timeout: 120000,
  baseURL: process.env.REACT_APP_API_GUIDELINES_URL,
})

createAuthInterceptor(api)

export const setAuthorizationHeader = ({ token, isLoggedIn, company, id, jwtToken }) => {
  if (isLoggedIn) {
    let authorizationHeaderValue

    if (jwtToken) {
      authorizationHeaderValue = jwtToken
    } else if (token) {
      authorizationHeaderValue = `Bearer ${token}`
    }

    api.defaults.headers['Authorization'] = authorizationHeaderValue
    api.defaults.headers['company'] = company
    api.defaults.headers['id'] = id
  } else {
    delete api.defaults.headers['Authorization']
  }
}

export const postGuideline = (body, file) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))

  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }
  Object.entries(body).forEach(([key, value]) => {
    if (value != null) formData.append(key, value)
  })

  return api.post('/api/1.0/guidelines', formData)
}

export const getGuideline = () => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.get('/api/1.0/guidelines')
}

export const getAvatar = () => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.get('/api/1.0/guidelines/avatar')
}

export const putGuideline = (body) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))
  return api.put('/api/1.0/guideliines', body)
}

export const updateTerms = async (file) => {
  setAuthorizationHeader(secureLs.get('appc-auth-mkplace'))

  const formData = new FormData()
  if (file) {
    formData.append('file', file)
  }

  return api.post('/api/1.0/terms-of-usage', formData)
}
